import { ServicingProvider } from "@app/projects/results/servicing-provider";
import { AccessPointForProjection } from "@app/projects/results/projection-provider";
import { ProviderNetworkTypeEnum } from "@app/shared/enums/providerNetworkTypeEnum";

export function convertServicingProvidersToAccessPoints(
  servicingProviders: ServicingProvider[],
  networkType: ProviderNetworkTypeEnum,
  specialtyGroupCode: string,
): AccessPointForProjection[] {
  return servicingProviders.map(servicingProvider => ({
    npi: servicingProvider.npi,
    professionalAffiliationId: servicingProvider.professionalAffiliationId,
    providerId: servicingProvider.providerId,
    providerNetworkType: networkType,
    specialtyGroupCode: specialtyGroupCode,
    tin: servicingProvider.tin,
  }));
}